import { Breadcrumbs, Link, Typography } from "@mui/material"
import React from "react"
import { useLocation } from "react-router-dom"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"

export const BreadCrumbCustom = () => {
  const location = useLocation()

  React.useEffect(() => {}, [location.pathname])
  const pathnames = location.pathname.split("/").filter((x) => x)

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ textTransform: "capitalize", mt: "10px", mb: 2 }}
    >
      <Link
        sx={{ fontSize: "15px" }}
        underline="hover"
        color="inherit"
        href="/"
      >
        Home
      </Link>
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1
        const to = `/${pathnames.slice(0, index + 1).join("/")}`

        return (
          <Link
            key={index}
            sx={{ fontSize: "15px" }}
            underline="hover"
            color={last ? "text.primary" : "inherit"}
            href={to}
          >
            {value}
          </Link>
        )
      })}
    </Breadcrumbs>
  )
}
